import { __decorate } from "tslib";
import { InputSwitchInstruction, LayoutPanelInstruction } from '@common/instructions/frontend-shared';
import { NotificationsFrontendSharedModule } from '@common/notifications/frontend-shared';
import { FrontendFeaturePlugin, provideRootRoutes } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import { VirtualPropertyHelper } from '@core/shared/virtual-properties';
import * as i0 from "@angular/core";
let NotificationsFrontendAdminFeature = /*#__PURE__*/(() => {
  let NotificationsFrontendAdminFeature = class NotificationsFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/notifications/frontend-admin","featureId":"common-notifications"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Benachrichtigungen',
          priority: 1,
          routerLink: 'notifications/create',
          icon: 'bell'
        }]
      });
      const instructions = [new InputSwitchInstruction({
        formControlName: VirtualPropertyHelper.accessor('receiveNotificationsByMail'),
        inlineLabels: 'Benachrichtigungen per E-Mail erhalten',
        orientation: 'vertical'
      })];
      functionality.defineModelInstructions([{
        modelId: 'UserItem',
        displayContext: ['admin', 'crud'],
        displayInEditModes: ['edit'],
        targetSlotId: 'sidebar',
        instructions: [new LayoutPanelInstruction({
          title: 'Benachrichtigungen',
          toggleable: true,
          instructions
        })]
      }, {
        modelId: 'PatchProfileCommonsRequest',
        instructions: [new LayoutPanelInstruction({
          title: 'Benachrichtigungen',
          toggleable: false,
          instructions
        })]
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵNotificationsFrontendAdminFeature_BaseFactory;
        return function NotificationsFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵNotificationsFrontendAdminFeature_BaseFactory || (ɵNotificationsFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(NotificationsFrontendAdminFeature)))(__ngFactoryType__ || NotificationsFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: NotificationsFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'notifications',
          loadChildren: () => import('@common/notifications/frontend/notifications-frontend.module').then(m => m.NotificationsFrontendModule)
        }, {
          path: 'notifications/create',
          loadChildren: () => import('./notifications-admin.module').then(m => m.NotificationsFrontendAdminModule)
        }])],
        imports: [NotificationsFrontendSharedModule]
      });
    }
  };
  NotificationsFrontendAdminFeature = __decorate([ClassName("NotificationsFrontendAdminFeature")], NotificationsFrontendAdminFeature);
  return NotificationsFrontendAdminFeature;
})();
export { NotificationsFrontendAdminFeature };